// Canonical bottom-nav tabs. Single source of truth shared by the nav bar
// (App.jsx) and the "tabs on bar" settings (ProfilePage). Labels are the
// Russian defaults; the UI localizes via the `nav_<id>` i18n keys with a
// fallback to `label`.
export const NAV = [
  { id: 'today',     icon: '☀️', label: 'Сегодня'     },
  { id: 'goals',     icon: '🎯', label: 'Цели'        },
  { id: 'education', icon: '🧠', label: 'Образование' },
  { id: 'body',      icon: '🩺', label: 'Тело'        },
  { id: 'mine',      icon: '📝', label: 'Заметки'     }, // бывш. «Моё»: неудачный нейминг — внутри заметки+идеи+wishlist (+плеер владельцу)
  { id: 'chat',      icon: '💬', label: 'Сообщения'   },
];

// Sub-modules that live inside «Моё» by default. Together with NAV they form
// the movable-module registry: any entry can be placed in the sidebar menu or
// inside the «Моё» hub (placement map `nav_placement_v1`, synced via ui_prefs).
export const MINE_CHILDREN = [
  { id: 'notes',    icon: '📝', label: 'Заметки' },
  { id: 'player',   icon: '🎵', label: 'Плеер'   }, // виден только владельцу (useIsOwner)
];

// Not movable: the day hub (единственная точка входа) и сам контейнер «Моё».
// Чат переносим: на телефоне он в любом случае живёт в шапке, а не в панели.
export const FIXED_MENU = ['today', 'mine'];

export const placementOf = (placement, id) =>
  (placement && placement[id]) || (MINE_CHILDREN.some(c => c.id === id) ? 'mine' : 'menu');

export function readPlacement() {
  try { const p = JSON.parse(localStorage.getItem('nav_placement_v1') || '{}'); return p && typeof p === 'object' ? p : {}; }
  catch { return {}; }
}

export function writePlacement(map) {
  try { localStorage.setItem('nav_placement_v1', JSON.stringify(map || {})); } catch { /* ignore */ }
  try { window.dispatchEvent(new Event('placement_changed')); } catch { /* ignore */ }
  // Раскладка — свойство аккаунта: тихо синкаем (телефон и десктоп расходились).
  try {
    const t = localStorage.getItem('auth_token');
    if (t) fetch('/api/users/me', { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${t}` },
      body: JSON.stringify({ uiPrefs: { placement: map } }) }).catch(() => {});
  } catch { /* offline — доедет при следующем изменении */ }
}
